import { safePrintWindow, escapeHtml } from '../../utils/printUtils';

// Shared 3-inch slip styles: fluid width (like the token slip) so it fills whatever paper the printer uses
export const THERMAL_CSS = `@page{margin:2mm}
  body{font-family:Arial,sans-serif;color:#000;margin:0;padding:0 2px;width:auto;font-size:15px;line-height:1.3}
  .c{text-align:center}.b{font-weight:800}.big{font-size:22px;font-weight:900}
  .hr{border-top:2px dashed #000;margin:6px 0}
  table{width:100%;border-collapse:collapse}td,th{padding:2px 0;vertical-align:top;font-size:15px}
  th{text-align:left;border-bottom:2px solid #000;font-weight:800}.n{text-align:right;white-space:nowrap;padding-left:6px}
  .tot td{border-top:2px solid #000;font-weight:900;font-size:16px}.sec{font-weight:900;margin-top:8px;text-transform:uppercase;font-size:15px;text-decoration:underline}
  .loss{font-weight:900}.sig{margin-top:34px;display:flex;justify-content:space-between}.sig span{border-top:1px solid #000;width:45%;text-align:center;font-size:13px}`;

export const THERMAL_HEAD = `<div class="c big">K.M. MULTI SPECIALITY CLINIC</div><div class="c" style="font-size:13px">Koliyanur &bull; 86085 95239</div>`;

const rs = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
const time = (iso) => (iso ? new Date(iso).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true }) : '');

export const printNursingEntries = (entries, dateLabel) => {
  const totals = {};
  const rows = entries.slice().sort((a, b) => (a.created_at || '').localeCompare(b.created_at || '')).map((e, i) => {
    const svc = (e.services || []).map((s) => {
      const t = totals[s.name] || (totals[s.name] = { count: 0, amount: 0 });
      t.count += s.quantity || 1;
      t.amount += (s.cost || 0) * (s.quantity || 1);
      return `${escapeHtml(s.name)}${(s.quantity || 1) > 1 ? ` ×${s.quantity}` : ''}`;
    }).join(', ');
    const who = `${e.patient_token ? `${escapeHtml(e.patient_token)} ` : ''}${escapeHtml(e.patient_name || 'Walk-in')}`;
    return `<tr><td>${i + 1}. <b>${who}</b> <span style="font-size:12px">${time(e.created_at)}</span><br/>${svc}</td><td class="n b">${rs(e.total_cost)}</td></tr>`;
  }).join('');
  const totRows = Object.entries(totals).map(([n, t]) => `<tr><td>${escapeHtml(n)}</td><td class="n">${t.count}</td><td class="n">${rs(t.amount)}</td></tr>`).join('');
  const grand = entries.reduce((s, e) => s + (e.total_cost || 0), 0);
  const body = `${THERMAL_HEAD}<div class="hr"></div>
    <div class="c b">NURSING ENTRIES &mdash; FOR PHARMACY</div><div class="c">${escapeHtml(dateLabel)}</div><div class="hr"></div>
    <table>${rows || '<tr><td>No entries</td></tr>'}</table><div class="hr"></div>
    <div class="sec">Service Totals</div>
    <table><tr><th>Service</th><th class="n">Qty</th><th class="n">Amt</th></tr>${totRows}
      <tr class="tot"><td>TOTAL (${entries.length} entries)</td><td></td><td class="n">${rs(grand)}</td></tr></table>
    <div class="sig"><span>Nurse</span><span>Pharmacy</span></div>
    <div class="c" style="font-size:12px;margin-top:6px">Printed ${new Date().toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true })}</div>`;
  safePrintWindow('Nursing Entries', `<style>${THERMAL_CSS}</style>${body}`);
};
